import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("a", {
      class: _normalizeClass([_ctx.store.dark ? 'text-white' : 'text-black', "donate-link"]),
      href: "#"
    }, "Donate", 2)
  ]))
}